import { publicClient, privateClient } from './client';
import { GiftCard } from './GiftCard';

const customGiftCard = (pub: boolean) => new GiftCard(pub ? publicClient : privateClient);
export default customGiftCard;
